
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanSphere as ObiBuoyCanSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-sphere.js';
 
 
 

 
 export const ObiBuoyCanSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-can-sphere',
   elementClass: ObiBuoyCanSphereElement,
   events: {
     
   }
  });
 
 